import React from 'react';
import { Printer, Copy, Edit2 } from 'lucide-react';

import { DemoBanner } from './DemoBanner';

export function TreatmentPlan() {
  return (
    <div className="bg-white border border-gray-200 rounded-xl p-6">
      <DemoBanner section="План терапии" />

      <div className="flex items-center justify-between mb-5 pb-4 border-b border-gray-100">
        <h3 className="text-xl font-semibold text-gray-900">План терапии</h3>
        <div className="flex items-center gap-4">
          <button className="flex items-center gap-1.5 text-sm text-gray-500 hover:text-gray-800" type="button">
            <Edit2 size={14} /> Редактировать
          </button>
          <button className="flex items-center gap-1.5 text-sm text-gray-500 hover:text-gray-800" type="button">
            <Printer size={14} /> Печать
          </button>
          <button className="flex items-center gap-1.5 text-sm text-gray-500 hover:text-gray-800" type="button">
            <Copy size={14} /> Копировать
          </button>
        </div>
      </div>

      <div className="space-y-6 text-sm text-gray-700">
        <section>
          <h4 className="font-bold text-gray-900 mb-2">Диагноз</h4>
          <p>F43.23 — Расстройство адаптации со смешанной тревогой и депрессивным настроением</p>
        </section>

        <section>
          <h4 className="font-bold text-gray-900 mb-3">Долгосрочные цели терапии</h4>
          <div className="space-y-3">
            {[
              {
                goal: 'Снижение тревоги',
                desc: 'Клиент научится управлять симптомами тревоги с использованием поведенческих техник',
              },
              {
                goal: 'Самосострадание',
                desc: 'Развитие здорового внутреннего диалога и снижение самокритики',
              },
              {
                goal: 'Границы',
                desc: 'Улучшение способности устанавливать и удерживать здоровые личные и профессиональные границы',
              },
            ].map((item, i) => (
              <div key={i} className="border border-gray-100 rounded-lg p-4">
                <p className="font-semibold text-gray-900 mb-1">{item.goal}</p>
                <p className="text-gray-600">{item.desc}</p>
              </div>
            ))}
          </div>
        </section>

        <section>
          <h4 className="font-bold text-gray-900 mb-3">Терапевтические методы</h4>
          <ul className="space-y-2">
            {[
              'Когнитивно-поведенческая терапия (КПТ)',
              'Техники осознанности и майндфулнесс',
              'Телесно-ориентированные практики',
              'Работа с внутренним критиком',
              'Техники регуляции эмоций',
            ].map((m, i) => (
              <li key={i} className="flex items-center gap-2">
                <span className="w-2 h-2 rounded-full bg-[#C41230] shrink-0" />
                {m}
              </li>
            ))}
          </ul>
        </section>

        <section>
          <h4 className="font-bold text-gray-900 mb-2">Частота встреч</h4>
          <p>1 раз в неделю, сессии по 50 минут. Пересмотр плана через 12 сессий.</p>
        </section>

        <section>
          <h4 className="font-bold text-gray-900 mb-2">Показания к завершению терапии</h4>
          <ul className="space-y-1">
            <li className="flex items-start gap-2">
              <span className="text-gray-400 mt-0.5">•</span>
              <span>Стабильное снижение тревоги по самооценке клиента</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-gray-400 mt-0.5">•</span>
              <span>Формирование устойчивых стратегий самопомощи</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-gray-400 mt-0.5">•</span>
              <span>Способность устанавливать границы без чрезмерной вины</span>
            </li>
          </ul>
        </section>
      </div>
    </div>
  );
}

